














import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { WordSearchPuzzle } from '@/wordsearch/types';

const puzzle = namespace('Puzzle');

@Component
export default class WordList extends Vue {
  @puzzle.State
  private puzzle!: WordSearchPuzzle;

  @puzzle.State
  private userAnswers!: Record<string, string[]>;

  @puzzle.State
  private gridSize!: number;

  @puzzle.Getter
  private cellHeight!: number;

  get foundAnswers() {
    return Object.keys(this.userAnswers);
  }

  get wordListStyle() {
    return `
      max-width: ${this.gridSize}px;
      min-width: ${this.gridSize * 0.3}px;
      max-height: ${this.gridSize}px;
      font-size: ${this.cellHeight * 0.6}px;
    `;
  }
}
